import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { GET_TIMELINE, KPI_DASHBOARD_DETAILS } from "../../constants";
import axios from "axios";
import dayjs from "dayjs";
import {
  Calendar,
  Clock,
  MapPin,
  Users,
  Briefcase,
  LineChart,
  User,
  FileText,
  Image,
} from "lucide-react";
import { Timeline } from "@mui/icons-material";
import TimelineDialog from "../reusable Component/TimelineDialog";
import { ChevronDownIcon, ChevronRightIcon } from "lucide-react";
import {
  Breadcrumbs,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const StatusChip = ({ status }) => {
  const getChipStyles = () => {
    switch (status.toLowerCase()) {
      case "completed":
        return "bg-green-100 text-green-800 border-green-200";
      case "not completed":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      case "cancelled":
        return "bg-red-100 text-red-800 border-red-200";
      case "hot":
        return "bg-red-100 text-red-800 border-red-200"; // Red
      case "warm":
        return "bg-yellow-100 text-yellow-800 border-yellow-200"; // Yellow
      case "cold":
        return "bg-blue-100 text-blue-800 border-blue-200"; // Blue
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  return (
    <span
      className={`px-2 py-1 text-xs font-medium rounded-full border ${getChipStyles()}`}
    >
      {status}
    </span>
  );
};

const KpiDetailsComponent = ({ startDate, endDate }) => {
  const location = useLocation();
  console.log("here");

  const [reportData, setReportData] = useState(null);
  const [activeTab, setActiveTab] = useState("summary");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchkpiDetailsbyBdm = async () => {
    const formattedStartDate =
      startDate == null || startDate === ""
        ? dayjs().subtract(6, "days").format("YYYY-MM-DD")
        : dayjs(startDate).format("YYYY-MM-DD");

    const formattedEndDate =
      endDate == null || endDate === ""
        ? dayjs().format("YYYY-MM-DD")
        : dayjs(endDate).format("YYYY-MM-DD");

    try {
      setLoading(true);
      const response = await axios.get(
        `${KPI_DASHBOARD_DETAILS}?bdmId=${localStorage.getItem(
          "username"
        )}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
      );
      setReportData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data", error);
      console.error("Error fetching data", error);
      setError("Failed to load BDM data");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchkpiDetailsbyBdm();
  }, []);

  const [openTimeline, setopenTimeline] = useState(false);
  const [timelineLogs, setTimelineLogs] = useState([]);
  const [custData, setCustData] = useState([]);

  const handletimelineClickMeeting = (row) => {
    setopenTimeline(true);
    setCustData(row.Lead);
    axios
      .get(`${GET_TIMELINE}/${row.LeadId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { leadLogs } = response.data;
        setTimelineLogs(leadLogs);
      })
      .catch((error) => {});
  };

  const handletimelineClickSiteVisit = (row) => {
    setopenTimeline(true);
    setCustData(row.LeadDetail);
    axios
      .get(`${GET_TIMELINE}/${row.LeadDetailId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        const { leadLogs } = response.data;
        setTimelineLogs(leadLogs);
      })
      .catch((error) => {});
  };

  // Format date for display
  const formatDate1 = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleExpand = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const getCustomersByGroupId = (groupId) => {
    console.log(groupId);

    return (
      reportData?.details?.group_meetings?.find((g) => g.group_id === groupId)
        ?.customers || []
    );
  };

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalVisits = reportData?.details?.field_visits?.length || 0;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = reportData?.details?.field_visits?.slice(
    indexOfFirstRow,
    indexOfLastRow
  );
  const totalPages = Math.ceil(totalVisits / rowsPerPage);

  const [meetingPage, setMeetingPage] = useState(1);
  const allMeetings = reportData?.details?.meetings || [];
  const totalMeetings = allMeetings.length;
  const totalMeetingPages = Math.ceil(totalMeetings / rowsPerPage);

  const startIndex = (meetingPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedMeetings = allMeetings.slice(startIndex, endIndex);

  const officerowsPerPage = 5; // you can change this as needed
  const [page, setPage] = useState(1);

  const groupMeetingsPerPage = 5;
  const [groupMeetingsPage, setGroupMeetingsPage] = useState(1);

  const totalGroupMeetings = reportData?.details?.group_meetings?.length || 0;
  const totalGroupMeetingPages = Math.ceil(
    totalGroupMeetings / groupMeetingsPerPage
  );

  const lastGroupMeetingIndex = groupMeetingsPage * groupMeetingsPerPage;
  const firstGroupMeetingIndex = lastGroupMeetingIndex - groupMeetingsPerPage;

  const paginatedGroupMeetings =
    reportData?.details?.group_meetings?.slice(
      firstGroupMeetingIndex,
      lastGroupMeetingIndex
    ) || [];

  // State to handle dialog
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Handle image preview
  const handleImageClick = (imgUrl) => {
    setSelectedImage(imgUrl);
    setOpenImageDialog(true);
  };

  const [selectedFilter, setSelectedFilter] = useState(null);

  // Loading state
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow p-12 flex justify-center items-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-gray-600">Loading BDM data...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error || !reportData) {
    return (
      <div className="bg-white rounded-lg shadow p-12">
        <div className="text-center">
          <p className="text-red-500 text-lg mb-2">Error</p>
          <p className="text-gray-600">{error || "Could not load BDM data"}</p>
          <button
            onClick={fetchkpiDetailsbyBdm}
            className="mt-4 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Render tabs content
  const renderTabContent = () => {
    switch (activeTab) {
      case "summary":
        return (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Meetings */}
            <div className="bg-white p-4 rounded-lg shadow">
              <h3 className="text-lg font-medium flex items-center">
                <Briefcase className="mr-2 text-blue-500" size={20} />
                Meetings
              </h3>
              <p className="text-xs text-gray-400 mb-3">(Office + Field)</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="bg-blue-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">Total</p>
                  <p className="text-2xl font-bold">
                    {reportData?.targets?.unique_meetings?.achievement || 0} /{" "}
                    {reportData?.targets?.unique_meetings?.target || 0}
                  </p>
                </div>
                <div className="bg-blue-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">Unique</p>
                  <p className="text-2xl font-bold">
                    {reportData?.summary?.total_unique_meetings || 0}
                  </p>
                </div>
              </div>
            </div>

            {/* Site Visits */}
            <div className="bg-white p-4 rounded-lg shadow">
              <h3 className="text-lg font-medium mb-4 flex items-center">
                <MapPin className="mr-2 text-green-500" size={20} />
                Site Visits
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="bg-green-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">Total</p>
                  <p className="text-2xl font-bold">
                    {reportData?.targets?.unique_field_visits?.achievement || 0}{" "}
                    / {reportData?.targets?.unique_field_visits?.target || 0}
                  </p>
                </div>
                <div className="bg-green-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">Unique</p>
                  <p className="text-2xl font-bold">
                    {reportData?.summary?.total_unique_field_visits || 0}
                  </p>
                </div>
              </div>
            </div>

            {/* Group Meetings */}
            <div className="bg-white p-4 rounded-lg shadow">
              <h3 className="text-lg font-medium mb-4 flex items-center">
                <Users className="mr-2 text-purple-500" size={20} />
                Group Meetings
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="bg-purple-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">Total</p>
                  <p className="text-2xl font-bold">
                    {reportData?.targets?.group_meetings?.achievement || 0} /{" "}
                    {reportData?.targets?.group_meetings?.target || 0}
                  </p>
                </div>
                <div className="bg-purple-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">Total Customers</p>
                  <p className="text-2xl font-bold">
                    {reportData?.summary?.total_group_meetings_customers || 0}
                  </p>
                </div>
              </div>
            </div>

            {/* Office Visits */}
            <div className="bg-white p-4 rounded-lg shadow md:col-span-3">
              <h3 className="text-lg font-medium mb-4 flex items-center">
                <MapPin className="mr-2 text-orange-500" size={20} />
                Office Visits
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="bg-orange-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">BO Visits</p>
                  <p className="text-2xl font-bold">
                    {reportData?.summary?.bo_visit || 0}
                  </p>
                </div>
                <div className="bg-orange-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">RO Visits</p>
                  <p className="text-2xl font-bold">
                    {reportData?.summary?.ro_visit || 0}
                  </p>
                </div>
                <div className="bg-orange-50 p-3 rounded-md">
                  <p className="text-sm text-gray-500">HO Visits</p>
                  <p className="text-2xl font-bold">
                    {reportData?.summary?.ho_visit || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      case "meetings":
        return (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto md:overflow-x-visible">
              <table className="hidden md:table min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Customer name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Mobile No
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Location
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Category
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sub-Category
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {reportData?.details?.meetings?.length > 0 ? (
                    paginatedMeetings.map((meeting) => (
                      <tr key={meeting.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {formatDate(meeting?.action_date)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {meeting?.Lead?.CustomerName || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {meeting?.Lead?.MobileNo || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {meeting?.Lead?.location || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-capitalize">
                          <StatusChip
                            status={
                              meeting?.completion_status ?? "not completed"
                            }
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-capitalize">
                          {meeting?.Lead === null ? (
                            "-"
                          ) : (
                            <StatusChip status={meeting?.Lead?.category} />
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {meeting?.Lead?.sub_category || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          <button
                            className="text-blue-600 hover:text-blue-800"
                            title="View Timeline"
                            onClick={() => handletimelineClickMeeting(meeting)}
                          >
                            <Timeline size={18} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="8"
                        className="px-6 py-4 text-center text-sm text-gray-500"
                      >
                        No meetings found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Mobile View */}
              <div className="block md:hidden divide-y">
                {reportData?.details?.meetings?.length > 0 ? (
                  paginatedMeetings.map((meeting) => (
                    <div key={meeting.id} className="p-4">
                      <div className="text-sm text-gray-500 mb-2">
                        <strong className="text-gray-700">Date:</strong>{" "}
                        {formatDate(meeting.action_date)}
                      </div>
                      <div className="text-sm text-gray-500 mb-2">
                        <strong className="text-gray-700">Customer:</strong>{" "}
                        {meeting?.Lead?.CustomerName}
                      </div>
                      <div className="text-sm text-gray-500 mb-2">
                        <strong className="text-gray-700">Mobile:</strong>{" "}
                        {meeting?.Lead?.MobileNo}
                      </div>
                      <div className="text-sm text-gray-500 mb-2">
                        <strong className="text-gray-700">Location:</strong>{" "}
                        {meeting?.Lead?.location}
                      </div>
                      <div className="text-sm text-gray-500 mb-2 text-capitalize">
                        <strong className="text-gray-700">Status:</strong>{" "}
                        <StatusChip
                          status={meeting.completion_status ?? "not completed"}
                        />
                      </div>
                      <div className="text-sm text-gray-500 mb-2 text-capitalize">
                        <strong className="text-gray-700">Category:</strong>{" "}
                        {meeting.Lead === null ? (
                          "-"
                        ) : (
                          <StatusChip status={meeting?.Lead?.category} />
                        )}
                      </div>
                      <div className="text-sm text-gray-500 mb-2">
                        <strong className="text-gray-700">Sub-Category:</strong>{" "}
                        {meeting?.Lead?.sub_category}
                      </div>
                      <div className="flex justify-end mt-2">
                        <button
                          className="text-blue-600 hover:text-blue-800"
                          title="View Timeline"
                          onClick={() => handletimelineClickMeeting(meeting)}
                        >
                          <Timeline size={18} />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-4 text-center text-sm text-gray-500">
                    No meetings found
                  </div>
                )}
              </div>

              {totalMeetingPages > 1 && (
                <div className="flex flex-col sm:flex-row justify-between items-center px-4 py-3 bg-gray-50 text-sm text-gray-700 gap-2">
                  <div>
                    Showing {startIndex + 1}–{Math.min(endIndex, totalMeetings)}{" "}
                    of {totalMeetings} meetings
                  </div>
                  <div className="space-x-2">
                    <button
                      onClick={() =>
                        setMeetingPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={meetingPage === 1}
                      className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                      Previous
                    </button>
                    <span>
                      Page {meetingPage} of {totalMeetingPages}
                    </span>
                    <button
                      onClick={() =>
                        setMeetingPage((prev) =>
                          Math.min(prev + 1, totalMeetingPages)
                        )
                      }
                      disabled={meetingPage === totalMeetingPages}
                      className="px-3 py-1 border rounded disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      case "fieldVisits":
        return (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Customer Name
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Mobile Number
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Location
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Category
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sub-Category
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {reportData?.details?.field_visits?.length > 0 ? (
                    currentRows.map((visit) => (
                      <tr key={visit.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 font-medium">
                          {formatDate(visit.createdAt)}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                          {visit.LeadDetail.CustomerName}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                          {visit.LeadDetail.MobileNo}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                          {visit.LeadDetail.location}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-capitalize">
                          <StatusChip status={visit.LeadDetail.category} />
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                          {visit.LeadDetail.sub_category}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-blue-600">
                          <button
                            title="View Timeline"
                            onClick={() => handletimelineClickSiteVisit(visit)}
                            className="hover:text-blue-800"
                          >
                            <Timeline size={18} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="7"
                        className="px-4 py-4 text-center text-sm text-gray-500"
                      >
                        No field visits found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile Cards */}
            <div className="block md:hidden divide-y">
              {reportData?.details?.field_visits?.length > 0 ? (
                currentRows.map((visit) => (
                  <div key={visit.id} className="p-4">
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">Date: </strong>
                      {formatDate(visit.createdAt)}
                    </div>
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">Customer Name: </strong>
                      {visit.LeadDetail.CustomerName}
                    </div>
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">Mobile: </strong>
                      {visit.LeadDetail.MobileNo}
                    </div>
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">Location: </strong>
                      {visit.LeadDetail.location}
                    </div>
                    <div className="text-sm text-gray-500 mb-2 text-capitalize">
                      <strong className="text-gray-700">Category: </strong>
                      <StatusChip status={visit.LeadDetail.category} />
                    </div>
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">Sub-Category: </strong>
                      {visit.LeadDetail.sub_category}
                    </div>
                    <div className="flex justify-end mt-2">
                      <button
                        className="text-blue-600 hover:text-blue-800"
                        title="View Timeline"
                        onClick={() => handletimelineClickSiteVisit(visit)}
                      >
                        <Timeline size={18} />
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-sm text-gray-500">
                  No field visits found
                </div>
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex flex-col sm:flex-row justify-between items-center px-4 py-3 bg-gray-50 text-sm text-gray-700 space-y-2 sm:space-y-0 sm:space-x-2">
                <div>
                  Showing {indexOfFirstRow + 1} -{" "}
                  {Math.min(indexOfLastRow, totalVisits)} of {totalVisits} field
                  visits
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={currentPage === 1}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      case "groupMeetings":
        return (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            {/* Table view for screens sm and up */}
            <div className="hidden sm:block overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3" />
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Created Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Group ID
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Title
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Customer Count
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {paginatedGroupMeetings.map((meeting) => {
                    const isExpanded = expandedRows.includes(meeting.group_id);
                    const customers = getCustomersByGroupId(meeting.group_id);
                    return (
                      <React.Fragment key={meeting.group_id}>
                        <tr className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <button
                              onClick={() => toggleExpand(meeting.group_id)}
                            >
                              {isExpanded ? (
                                <ChevronDownIcon className="h-5 w-5 text-gray-600" />
                              ) : (
                                <ChevronRightIcon className="h-5 w-5 text-gray-600" />
                              )}
                            </button>
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500">
                            {formatDate(meeting.created_at)}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500">
                            {meeting.group_id}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500">
                            {meeting.group_meeting_title}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500">
                            {meeting.customer_count}
                          </td>
                        </tr>
                        {isExpanded && customers.length > 0 && (
                          <tr>
                            <td colSpan="5" className="px-6 pb-6">
                              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <div className="text-sm font-semibold mb-2">
                                  Participants:
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 text-sm">
                                  {customers.map((cust) => (
                                    <div
                                      key={cust.id}
                                      className="p-2 bg-white rounded border"
                                    >
                                      <div>
                                        <strong>Name:</strong>{" "}
                                        {cust.customer_name}
                                      </div>
                                      <div>
                                        <strong>Mobile:</strong> {cust.mobile}
                                      </div>
                                      <div>
                                        <strong>Location:</strong>{" "}
                                        {cust.location}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                  {paginatedGroupMeetings.length === 0 && (
                    <tr>
                      <td
                        colSpan="5"
                        className="px-6 py-4 text-center text-sm text-gray-500"
                      >
                        No group meetings found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Card layout for small screens */}
            <div className="sm:hidden divide-y divide-gray-200">
              {paginatedGroupMeetings.length > 0 ? (
                paginatedGroupMeetings.map((meeting) => {
                  const isExpanded = expandedRows.includes(meeting.group_id);
                  const customers = getCustomersByGroupId(meeting.group_id);
                  return (
                    <div key={meeting.group_id} className="p-4">
                      <div className="flex justify-between items-center mb-2">
                        <div className="text-sm font-medium text-gray-900">
                          {meeting.group_meeting_title}
                        </div>
                        <button onClick={() => toggleExpand(meeting.group_id)}>
                          {isExpanded ? (
                            <ChevronDownIcon className="h-5 w-5 text-gray-600" />
                          ) : (
                            <ChevronRightIcon className="h-5 w-5 text-gray-600" />
                          )}
                        </button>
                      </div>
                      <div className="text-sm text-gray-500">
                        <div>
                          <strong>Date:</strong>{" "}
                          {formatDate(meeting.created_at)}
                        </div>
                        <div>
                          <strong>Group ID:</strong> {meeting.group_id}
                        </div>
                        <div>
                          <strong>Customer Count:</strong>{" "}
                          {meeting.customer_count}
                        </div>
                      </div>

                      {isExpanded && customers.length > 0 && (
                        <div className="mt-4 bg-gray-50 p-3 rounded-lg border">
                          <div className="text-sm font-semibold mb-2">
                            Participants:
                          </div>
                          <div className="space-y-2">
                            {customers.map((cust) => (
                              <div
                                key={cust.id}
                                className="p-2 bg-white rounded border text-sm"
                              >
                                <div>
                                  <strong>Name:</strong> {cust.customer_name}
                                </div>
                                <div>
                                  <strong>Mobile:</strong> {cust.mobile}
                                </div>
                                <div>
                                  <strong>Location:</strong> {cust.location}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="p-4 text-center text-sm text-gray-500">
                  No group meetings found
                </div>
              )}
            </div>

            {/* Pagination (shared) */}
            {totalGroupMeetingPages > 1 && (
              <div className="flex flex-col sm:flex-row justify-between items-center px-6 py-3 bg-gray-50 text-sm text-gray-700 gap-2">
                <div>
                  Showing {firstGroupMeetingIndex + 1} -{" "}
                  {Math.min(lastGroupMeetingIndex, totalGroupMeetings)} of{" "}
                  {totalGroupMeetings} group meetings
                </div>
                <div className="space-x-2">
                  <button
                    onClick={() =>
                      setGroupMeetingsPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={groupMeetingsPage === 1}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <span>
                    Page {groupMeetingsPage} of {totalGroupMeetingPages}
                  </span>
                  <button
                    onClick={() =>
                      setGroupMeetingsPage((prev) =>
                        Math.min(prev + 1, totalGroupMeetingPages)
                      )
                    }
                    disabled={groupMeetingsPage === totalGroupMeetingPages}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        );
      case "officeVisits":
        const boVisits = reportData?.details?.visits?.bo_visit || [];
const roVisits = reportData?.details?.visits?.ro_visit || [];
const hoVisits = reportData?.details?.visits?.ho_visit || [];

const allVisits = [
  ...boVisits.map((v) => ({ ...v, type: "BO Visit" })),
  ...roVisits.map((v) => ({ ...v, type: "RO Visit" })),
  ...hoVisits.map((v) => ({ ...v, type: "HO Visit" })),
];

// 🔽 Apply filter
const filteredVisits = selectedFilter
  ? allVisits.filter((v) => v.type === selectedFilter)
  : allVisits;

const totalOfficeVisits = filteredVisits.length;
const totalofficePages = Math.ceil(totalOfficeVisits / officerowsPerPage);
const indexOfLastRowOffice = page * officerowsPerPage;
const indexOfFirstRowOffice = indexOfLastRowOffice - officerowsPerPage;

const paginatedVisits = filteredVisits.slice(
  indexOfFirstRowOffice,
  indexOfLastRowOffice
);


        return (
          <>
          <div className="flex flex-wrap gap-2 px-4 py-2 bg-gray-50">
          {["RO Visit", "HO Visit", "BO Visit"].map((type) => (
            <button
              key={type}
              onClick={() => setSelectedFilter((prev) => (prev === type ? null : type))}
              className={`px-3 py-1 rounded-full text-sm border ${
                selectedFilter === type
                  ? "bg-blue-600 text-white border-blue-600"
                  : "bg-white text-gray-700 border-gray-300"
              }`}
            >
              {type}
            </button>
          ))}
        </div>
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="hidden sm:block overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Type
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Branch / RO
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Purpose
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Concern Person
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Admin Task
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Image 1
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Image 2
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Remarks
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {paginatedVisits.map((visit, index) => (
                    <tr
                      key={`${visit.type}-${visit.id}-${index}`}
                      className="hover:bg-gray-50"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {formatDate(visit.action_date)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit.specific_action}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit.specific_action === "BO Visit"
                          ? visit?.travel_form_details?.branchName || "-"
                          : visit.specific_action === "RO Visit"
                          ? visit?.travel_form_details?.regionalOfficeName ||
                            "-"
                          : "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit?.travel_form_details?.purposeForVisit || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit?.travel_form_details?.purposeForVisit ===
                        "Meeting_with_RH_BM_ZH"
                          ? visit?.travel_form_details?.concernPersonName || "-"
                          : "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit?.travel_form_details?.purposeForVisit ===
                        "admin_work"
                          ? visit?.travel_form_details?.adminTaskSelect || "-"
                          : "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit?.travel_form_details?.mandatoryVisitImage ? (
                          <Box
                            onClick={() => {
                              setSelectedImage(
                                visit.travel_form_details.mandatoryVisitImage
                              );
                              setOpenImageDialog(true);
                            }}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              color: "primary.main",
                              cursor: "pointer",
                            }}
                          >
                            <Image />
                          </Box>
                        ) : (
                          "No image"
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit?.travel_form_details?.optionalVisitImage ? (
                          <Box
                            onClick={() => {
                              setSelectedImage(
                                visit.travel_form_details.optionalVisitImage
                              );
                              setOpenImageDialog(true);
                            }}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              color: "primary.main",
                              cursor: "pointer",
                            }}
                          >
                            <Image />
                          </Box>
                        ) : (
                          "No image"
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {visit.remarks}
                      </td>
                    </tr>
                  ))}
                  {allVisits.length === 0 && (
                    <tr>
                      <td
                        colSpan="9"
                        className="px-6 py-4 text-center text-sm text-gray-500"
                      >
                        No office visits found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile View */}
            <div className="block md:hidden divide-y">
              {paginatedVisits.map((visit, index) => (
                <div key={`${visit.type}-${visit.id}-${index}`} className="p-4">
                  <div className="text-sm text-gray-500 mb-2">
                    <strong className="text-gray-700">Date:</strong>{" "}
                    {formatDate(visit.action_date)}
                  </div>
                  <div className="text-sm text-gray-500 mb-2">
                    <strong className="text-gray-700">Type:</strong>{" "}
                    {visit.specific_action}
                  </div>
                  {visit.specific_action === "BO Visit" && (
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">Branch Name:</strong>{" "}
                      {visit?.travel_form_details?.branchName || "-"}
                    </div>
                  )}
                  {visit.specific_action === "RO Visit" && (
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">
                        Regional Office:
                      </strong>{" "}
                      {visit?.travel_form_details?.regionalOfficeName || "-"}
                    </div>
                  )}
                  <div className="text-sm text-gray-500 mb-2">
                    <strong className="text-gray-700">Purpose:</strong>{" "}
                    {visit?.travel_form_details?.purposeForVisit}
                  </div>
                  {visit?.travel_form_details?.purposeForVisit ===
                    "Meeting_with_RH_BM_ZH" && (
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">
                        Concern Person Name:
                      </strong>{" "}
                      {visit?.travel_form_details?.concernPersonName}
                    </div>
                  )}
                  {visit?.travel_form_details?.purposeForVisit ===
                    "admin_work" && (
                    <div className="text-sm text-gray-500 mb-2">
                      <strong className="text-gray-700">Admin Task:</strong>{" "}
                      {visit?.travel_form_details?.adminTaskSelect}
                    </div>
                  )}
                  <div className="text-sm text-gray-500 mb-2">
                    <strong className="text-gray-700">Remarks:</strong>{" "}
                    {visit.remarks}
                  </div>

                  <div className="text-sm text-gray-500 mb-2 flex items-center gap-1">
                    <strong className="text-gray-700">Visit Image1:</strong>
                    {visit?.travel_form_details?.mandatoryVisitImage ? (
                      <Box
                        onClick={() => {
                          setSelectedImage(
                            visit.travel_form_details.mandatoryVisitImage
                          );
                          setOpenImageDialog(true);
                        }}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          color: "primary.main",
                          cursor: "pointer",
                        }}
                      >
                        <Image />
                      </Box>
                    ) : (
                      <span>No image</span>
                    )}
                  </div>

                  <div className="text-sm text-gray-500 mb-2 flex items-center gap-1">
                    <strong className="text-gray-700">Visit Image2:</strong>
                    {visit?.travel_form_details?.optionalVisitImage ? (
                      <Box
                        onClick={() => {
                          setSelectedImage(
                            visit.travel_form_details.optionalVisitImage
                          );
                          setOpenImageDialog(true);
                        }}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          color: "primary.main",
                          cursor: "pointer",
                        }}
                      >
                        <Image />
                      </Box>
                    ) : (
                      <span>No image</span>
                    )}
                  </div>

                  <div className="text-sm text-gray-500 mb-2">
                    <strong className="text-gray-700">Remarks:</strong>{" "}
                    {visit.remarks}
                  </div>
                </div>
              ))}
              {allVisits.length === 0 && (
                <div className="text-center text-sm text-gray-500">
                  No office visits found
                </div>
              )}
            </div>

            {/* Pagination */}
            {totalofficePages > 1 && (
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center px-4 sm:px-6 py-3 bg-gray-50 text-sm text-gray-700 space-y-2 sm:space-y-0">
                <div className="text-center sm:text-left">
                  Showing {indexOfFirstRowOffice + 1} -{" "}
                  {Math.min(indexOfLastRowOffice, totalOfficeVisits)} of{" "}
                  {totalOfficeVisits} visits
                </div>
                <div className="flex justify-center sm:justify-end space-x-2">
                  <button
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                    disabled={page === 1}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <span className="px-2 py-1">{`Page ${page} of ${totalofficePages}`}</span>
                  <button
                    onClick={() =>
                      setPage((prev) => Math.min(prev + 1, totalofficePages))
                    }
                    disabled={page === totalofficePages}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
          </>
        );
      default:
        return <div>Select a tab to view details</div>;
    }

  };

  return (
    <>
      <div className="bg-gray-100 min-h-screen p-3">
        {/* Header */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
            <div className="flex items-center mb-4 md:mb-0">
              <div className="bg-blue-100 p-3 rounded-full mr-4">
                <User size={24} className="text-blue-600" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800">
                  {reportData?.bdm.name} ({reportData?.bdm.id})
                </h1>
                <p className="text-gray-500">Role: {reportData?.bdm.role}</p>
              </div>
            </div>
            <div className="flex items-center bg-gray-100 px-4 py-2 rounded-lg">
              <Calendar size={18} className="text-gray-500 mr-2" />
              <span className="text-gray-700">
                {formatDate1(reportData?.date_range?.start_date)} -{" "}
                {formatDate1(reportData?.date_range?.end_date)}
              </span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-6 bg-white rounded-lg shadow">
          <div className="border-b border-gray-200">
            <nav className="flex overflow-x-auto">
              <button
                onClick={() => setActiveTab("summary")}
                className={`px-4 py-4 font-medium text-sm whitespace-nowrap ${
                  activeTab === "summary"
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <LineChart size={16} className="inline mr-2" />
                Summary
              </button>
              <button
                onClick={() => setActiveTab("meetings")}
                className={`px-4 py-4 font-medium text-sm whitespace-nowrap ${
                  activeTab === "meetings"
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <Briefcase size={16} className="inline mr-2" />
                Meetings (
                {reportData?.details?.meetings
                  ? reportData?.details?.meetings.length
                  : 0}
                )
              </button>
              <button
                onClick={() => setActiveTab("fieldVisits")}
                className={`px-4 py-4 font-medium text-sm whitespace-nowrap ${
                  activeTab === "fieldVisits"
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <MapPin size={16} className="inline mr-2" />
                Site Visits (
                {reportData?.details?.field_visits
                  ? reportData?.details?.field_visits.length
                  : 0}
                )
              </button>
              <button
                onClick={() => setActiveTab("groupMeetings")}
                className={`px-4 py-4 font-medium text-sm whitespace-nowrap ${
                  activeTab === "groupMeetings"
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <Users size={16} className="inline mr-2" />
                Group Meetings (
                {reportData?.summary?.total_unique_group_meetings
                  ? reportData?.summary?.total_unique_group_meetings
                  : 0}
                )
              </button>
              <button
                onClick={() => setActiveTab("officeVisits")}
                className={`px-4 py-4 font-medium text-sm whitespace-nowrap ${
                  activeTab === "officeVisits"
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <FileText size={16} className="inline mr-2" />
                HO/RO/BO Visits (
                {(reportData?.summary?.bo_visit || 0) +
                  (reportData?.summary?.ho_visit || 0) +
                  (reportData?.summary?.ro_visit || 0)}
                )
              </button>
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">{renderTabContent()}</div>
        </div>
      </div>

      <Dialog
        open={openImageDialog}
        onClose={() => setOpenImageDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent
          sx={{ p: 0, position: "relative", backgroundColor: "black" }}
        >
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenImageDialog(false);
              setSelectedImage(null);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#fff",
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Image */}
          <img
            src={selectedImage}
            alt="Visit"
            style={{ width: "100%", height: "auto", display: "block" }}
          />
        </DialogContent>
      </Dialog>

      <TimelineDialog
        open={openTimeline}
        setOpen={setopenTimeline}
        timelineLogs={timelineLogs}
        custData={custData}
      ></TimelineDialog>
    </>
  );
};

export default KpiDetailsComponent;
